export const CHATAREA = "/";
export const LOGIN = "/login";
export const DASHBOARD = "/dashboard";
export const REQUEST_HISTORY = "/request/history";
export const BUY_NEW_TOKENS = "/buy/new/tokens";
export const NODATAFOUND = "/no-data-found";
export const WORKINPROGRESS = "/work-in-progress";
export const SOMETHING_WENT_WRONG = "/something-went-wrong-500";
